module.exports = __webpack_public_path__ + "img/tutorial-3.f4c240f4.png";